// extracted by mini-css-extract-plugin
export default {"blockContainer":"VS691y1HGmswfpTLRkp6","block":"yu7ndwFn9ypsG1AsFqHg"};